export const localRouter_meun_zs = [ //产业招商大脑导航栏顺序
//产业招商
{
    code: "A",
    switch: false,
    name: "",
    oldtext: "产业招商",
    type: "cyzs",
    url: "/enterpriseList?type=9&Pt=1",
    open: true,
    morebtn: false,
    icontype: "el-icon-menu",
    children: [{
            code: "A-LTQY",
            switch: true,
            name: "",
            oldtext: "龙头企业库",
            url: "/enterpriseList?type=9&Pt=1"
        },
        {
            code: "A-KCQY",
            switch: true,
            name: "",
            oldtext: "科创企业库",
            url: "/enterpriseList?type=2&Pt=2"
        },
        {
            code: "A-QBNZQY",
            switch: false,
            name: "",
            oldtext: "全部内资企业",
            url: "/totalEnterprises"
        },
        {
            code: "A-JWSSQY",
            switch: false,
            name: "",
            oldtext: "境外上市企业",
            url: "/foreignEnterprises"
        },
        {
            code: "A-WZQY",
            switch: true,
            name: "",
            oldtext: "外资企业库",
            url: "/forcapEnterprise"
        },
        {
            code: "A-TZJG",
            switch: false,
            name: "",
            oldtext: "投资机构",
            url: "/investment-institutions"
        },
        {
            code: "A-XZXM",
            switch: true,
            name: "",
            oldtext: "选址项目",
            url: "/siteProject",
            // newType: "VIP"
        },
        {
            code: "A-KYJG",
            switch: false,
            name: "",
            oldtext: "科研机构",
            url: "/innovative-resources"
        },
        // {
        //     code: "A-ZSDT",
        //     switch: false,
        //     name: "",
        //     oldtext: "招商地图",
        //     url: "/enterprise-mapsearch"
        // },
        {
            code: "A-XHSH",
            switch: false,
            name: "",
            oldtext: "协会商会",
            url: "/associationList"
        },
        {
            code: "A-ZYZ",
            switch: false,
            name: "",
            oldtext: "专业镇",
            url: "/professionalTown",
        },
    ]
},
//产业研究
{
    code: "B",
    switch: false,
    name: "",
    oldtext: "产业研究",
    url: "/allchain",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [{
            code: "B-QGTP",
            switch: false,
            name: "",
            oldtext: "全国图谱",
            url: "/allchain"
        },
        {
            code: "B-DDTP",
            switch: false,
            name: "",
            oldtext: "当地图谱",
            url: "/localChainList",
        },
        // {code:"B-CSDSJ",switch:true,name:"城市大数据",oldtext:"城市大数据",url:"/urbanBigDataList"},
        // {code:"B-BSDSJ",switch:true,name:"本市大数据",oldtext:"本市大数据",url:"/urbanBigData?id=locality"},
        {
            code: "B-YJBGK",
            switch: false,
            name: "",
            oldtext: "研究报告库",
            url: "report",
            // newType: "VIP"
        },
        {
            code: "B-HYYJAI",
            switch: true,
            name: "",
            oldtext: "行研智能体",
            url: "/trade",
            newType: "new"
        },
        {
            code: "B-TZXMK",
            switch: false,
            name: "",
            oldtext: "投资项目库",
            url: "invest"
        },
        {
            code: "B-NDXMK",
            switch: false,
            name: "",
            oldtext: "拿地项目库",
            url: "land"
        },
        {
            code: "B-CYSJK",
            switch: true,
            name: "产业数据库",
            oldtext: "产业数据库",
            url: "/industryLibrary",
            // newType:"NEW"
        },
        {
            code: "B-CYYQK",
            switch: false,
            name: "",
            oldtext: "产业园区库",
            url: "/industrialpark"
        },
        {
            code: "B-DTJC",
            switch: false,
            name: "",
            oldtext: "动态监测",
            url: "/investdynamic"
        },
        {
            code: "B-CYZC",
            switch: false,
            name: "",
            oldtext: "政策库",
            url: "/policylibrary" //policyLibrary-N policylibrary 2024.4.17暂时隐藏用新的产业政策代替
        },
        {
            code: "B-HYJHK",
            switch: true,
            name: "行业机会库",
            oldtext: "行业机会库",
            url: "/trade",
        },
        // {
        //     code: "T-QYTZBG",
        //     switch: true,
        //     name: "",
        //     oldtext: "企业投资动态报告",
        //     url: "freeReport",
        //     reportId: 10006, 
        // },
        // {code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
    ]
},
//智能推荐
{
    code: "C",
    switch: false,
    name: "",
    oldtext: "智能推荐",
    url: "/recommendation",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-opportunity",
    children: [{
            code: "C-CYLZSXS",
            switch: false,
            name: "",
            oldtext: "产业链招商",
            url: "/recommendation"
        },
        {
            code: "C-YSZSXS",
            switch: false,
            name: "",
            oldtext: "以商招商线索",
            url: "/investment-clues2"
        },
        // {code:"C-ZDQYZSXS",switch:false,name:"",oldtext:"重点区域招商线索",url:"/investment-clues1"},
        {
            code: "C-ZBZSXS",
            switch: false,
            name: "",
            oldtext: "资本招商线索",
            url: "/investment-clues3"
        },
        {
            code: "C-QYTZCK",
            switch: false,
            name: "",
            oldtext: "企业投资窗口",
            url: "/enterpriseInvestmentWindow",
        },  
        {
            code: "C-CYTZCK",
            switch: false,
            name: "",
            oldtext: "产业投资窗口",
            url: "/industryInvestmentWindow",
        }, 
        {
            code: "C-GLQYXS",
            switch: true,
            name: "",
            oldtext: "关联企业线索",
            url: "/associated-enterprise-clues",
        }, 
        {
            code: "C-GDXSTJ",
            switch: false,
            name: "",
            oldtext: "更多线索推荐",
            url: "/investment-clues1"
        },
    ]
},
//关系计算器
{
    code: "E",
    switch: false,
    name: "",
    oldtext: "关系计算器",
    url: "/enterprisesCityRelation",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: [{
            code: "E-QY－CSGXJSQ",
            switch: false,
            name: "",
            oldtext: "企业-城市 关系计算器",
            url: "/enterprisesCityRelation",
            // newType: "HOT",
        },
        {
            code: "E-GXJSQ",
            switch: false,
            name: "",
            oldtext: "企业-企业 关系计算器",
            url: "/relationalcalculator"
        },
        {
            code: "E-ZZDT",
            switch: false,
            name: "",
            oldtext: "作战地图",
            url: "/targetMap",
        },
        {
            code: "E-WDGXW",
            switch: false,
            name: "",
            oldtext: "我的关系网",
            url: "/userrelational"
        },
    ]
},
{
    code: "J",
    switch: false,
    name: "",
    oldtext: "本地投资趋势",
    url: "/localInvestAnalysis?type=1",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [{
            code: "J-BSXZTZFX",
            switch: true,
            name: "",
            oldtext: "本省新增投资分析",
            url: "/localInvestAnalysis?type=1",
            // newType: "New",
        },
        {
            code: "J-BS-XZTZFX",
            switch: true,
            name: "",
            oldtext: "本市新增投资分析",
            url: "/localInvestAnalysis?type=2",
            // newType: "New",
        },
    ]
},
{
    code: "J",
    switch: true,
    name: "区域竞争力研究",
    oldtext: "区域竞争力研究",
    type: "qyjzl",
    url: "/regional-competitiveness",
    open: true,
    icontype: "el-icon-s-management",
    children: [{
        code: "J-SSJZL",
        switch: true,
        name: "",
        oldtext: "省市竞争力研究",
        url: "/regional-competitiveness?type=1", 
        // newType:"NEW"
    },{
        code: "J-CSJZL",
        switch: true,
        name: "",
        oldtext: "城市竞争力研究",
        url: "/regional-competitiveness?type=2", 
        // newType:"NEW"
    }, 
    ],},
//工作台
{
    code: "E",
    switch: false,
    name: "",
    oldtext: "工作台",
    url: "/workbench",
    open: false,
    openicon: true,
    morebtn: false,
    icontype: "el-icon-s-cooperation",
    children: [{
            code: "E-MBQY",
            switch: false,
            name: "",
            oldtext: "目标企业",
            url: "/focusenterprises"
        }, 
        {
                code: "E-DBQY",
                switch: true,
                name: "",
                oldtext: "企业对比",
                url: "/enterprise-compare",
                // newType:'NEW',
            },
        {
            code: "E-TJFX",
            switch: false,
            name: "",
            oldtext: "统计分析",
            url: "/statisticalAnalysis"
        },
        {
            code: "E-XMGL",
            switch: false,
            name: "",
            oldtext: "项目管理",
            url: "/projectmanagement"
        },
        {
            code: "E-GJJL",
            switch: false,
            name: "",
            oldtext: "跟进记录",
            url: "/followuprecord"
        },
        {
            code: "E-DBJL",
            switch: false,
            name: "",
            oldtext: "待办记录",
            url: "/todolist"
        },
    ]
},
// {code:"E-XTGL",switch:false,name:"",oldtext:"系统管理",url:"/systemManagement"}, 在前端默认隐藏系统管理  具体原因不记得了
//城市监测
{
    code: "D",
    switch: false,
    name: "",
    oldtext: "城市监测",
    url: "/hongguanshuju-saas",
    open: false,
    openicon: true,
    morebtn: false,
    icontype: 'el-icon-view',
    children: [
        // {
        //     code: "D-ZHFZ",
        //     switch: false,
        //     name: "",
        //     oldtext: "综合发展",
        //     url: "/hongguanshuju-saas"
        // },
        {
            code: "D-ZSHJ",
            switch: false,
            name: "",
            oldtext: "招商环境",
            url: "/zhaoshanghuanjing2-saas"
        },
        {
            code: "D-CYFZ",
            switch: false,
            name: "",
            oldtext: "产业发展",
            url: "/chanyeyongdi-saas"
        },
    ]
},
//个人中心
{
    code: "F",
    switch: false,
    name: "",
    oldtext: "个人中心",
    url: "/baseInformation",
    open: false,
    openicon: true,
    morebtn: false,
    icontype: "el-icon-s-custom",
    children: [{
            code: "F-GZLY",
            switch: false,
            name: "",
            oldtext: "关注领域",
            url: "/userFocus"
        },
        {
            code: "F-JBZL",
            switch: false,
            name: "",
            oldtext: "基本资料",
            url: "/baseInformation"
        },
        {
            code: "F-MMXG",
            switch: false,
            name: "",
            oldtext: "密码修改",
            url: "/editPassword"
        },
        {
            code: "F-FWSC",
            switch: false,
            name: "",
            oldtext: "服务手册",
            url: "/servicebook"
        },
        {
            code: "F-TCZH",
            switch: false,
            name: "",
            oldtext: "退出账号",
            url: "loginout"
        },
    ]
},
]